import { render, staticRenderFns } from "./PartnerDetail.vue?vue&type=template&id=ead7497a&scoped=true&"
import script from "./PartnerDetail.vue?vue&type=script&lang=js&"
export * from "./PartnerDetail.vue?vue&type=script&lang=js&"
import style0 from "./PartnerDetail.vue?vue&type=style&index=0&id=ead7497a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead7497a",
  null
  
)

export default component.exports